import React from 'react'
import PropTypes from 'prop-types'
import storage from 'utils/storage'
import intl from 'react-intl-universal'
import { locales } from 'locales'

const withBaseHelper = Component => class extends React.Component {
  static get propTypes() {
    return { locale: PropTypes.string.isRequired }
  }

  static get defaultProp() {
    return { locale: 'en' }
  }

  constructor(props) {
    super(props)

    storage.set('serverProps', props)

    const currentLocale = props.locale || 'en'
    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: locales(currentLocale),
      },
    })
  }

  render() {
    return <Component {...this.props} />
  }
}

export default withBaseHelper
